// eslint-disable-next-line import/prefer-default-export
export const suitChecker = (cards) => {
  const shirts = cards.map((shirt) => shirt[1]).sort((a, b) => a.localeCompare(b));
  if (
    shirts[0] !== shirts[1]
    && shirts[0] !== shirts[2]
    && shirts[0] !== shirts[3]
    && shirts[1] !== shirts[2]
    && shirts[1] !== shirts[3]
    && shirts[2] !== shirts[3]
  ) {
    return 'rainbow';
  }
  if (shirts[0] === shirts[1] && shirts[0] === shirts[2] && shirts[0] === shirts[3]) return 'mono';
  if (shirts[0] === shirts[1] && shirts[2] === shirts[3]) return 'double';
  return 'single';
};
